import React, { useState, useEffect } from "react";
import "./Navbar.css";
import { HiMenuAlt3, HiX } from "react-icons/hi";

const Navbar = () => {
  const [nav, setNav] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [activeSection, setActiveSection] = useState("home");

  const links = [
    { id: 1, link: "home", label: "Home" },
    { id: 2, link: "about", label: "About" },
    { id: 3, link: "skills", label: "Skills" },
    { id: 4, link: "experience", label: "Experience" },
    { id: 5, link: "projects", label: "Projects" },
    { id: 6, link: "certifications", label: "Certifications" },
    { id: 7, link: "contact", label: "Contact" },
  ];

  useEffect(() => {
    const handleScrollAndTracking = () => {
      if (window.scrollY > 20) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }

      const scrollPosition = window.scrollY + 120;
      
      for (const item of links) {
        const element = document.getElementById(item.link);
        if (element) {
          const offsetTop = element.offsetTop;
          const offsetHeight = element.offsetHeight;

          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(item.link);
            break;
          }
        }
      }
    };

    window.addEventListener("scroll", handleScrollAndTracking);
    return () => window.removeEventListener("scroll", handleScrollAndTracking);
  }, []);

  useEffect(() => {
    if (nav) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }
    return () => {
      document.body.style.overflow = "unset";
    };
  }, [nav]);

  return (
    <nav className={`custom-navbar ${scrolled ? "navbar-scrolled" : ""}`}>
      {/* Brand Logo Identity */}
      <a href="#home" className="navbar-logo">
        Chitrarasu<span>.dev</span>
      </a>

      {/* Desktop Main Navigation Links */}
      <ul className="navbar-desktop-links">
        {links.map(({ id, link, label }) => {
          const isActive = activeSection === link;
          return (
            <li key={id}>
              <a
                href={`#${link}`}
                className={`nav-item-link ${isActive ? "active" : ""}`}
              >
                {label}
              </a>
            </li>
          );
        })}
      </ul>

      {/* Desktop Secondary Action Button */}
      <div className="navbar-cta-wrapper">
        <a href="#contact" className="navbar-cta-btn">
          Let's Talk
        </a>
      </div>

      {/* Mobile Menu Icon Toggle */}
      <button
        onClick={() => setNav(!nav)}
        aria-label="Toggle navigation menu"
        className="navbar-mobile-toggle"
      >
        {nav ? <HiX size={26} /> : <HiMenuAlt3 size={26} />}
      </button>

      {/* Mobile Sidebar Slider Menu Overlay */}
      <div className={`navbar-mobile-drawer ${nav ? "drawer-open" : ""}`}>
        <ul className="navbar-mobile-links">
          {links.map(({ id, link, label }) => {
            const isActive = activeSection === link;
            return (
              <li key={id}>
                <a
                  onClick={() => setNav(false)}
                  href={`#${link}`}
                  className={`mobile-item-link ${isActive ? "active" : ""}`}
                >
                  {label}
                </a>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
};

export default Navbar;